@if (displayAddress) {
<checkout-address-model [model]="shippingAddressModel" />
}

@if (displayCollection) {
<checkout-collection-status [bookingCode]="checkoutFormComponent.data.shipping.additionalData.booking_code"
                            [storeId]="checkoutFormComponent.data.shipping.additionalData.store_id" />
}